export default __webpack_public_path__ + "static/media/quatroClosed.6cdafe65.jpg";